import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import RecipeFinder from './RecipeFinder';

function App() {
  return (
    <div className="App">
      <RecipeFinder />
    </div>
  );
}

export default App;
